module.exports = {
  locales: ['da'],
  defaultLocale: 'da',
  pages: {
    '*': ['common', 'footer', 'automatic-insurance', 'policy'],
    '/': ['home', 'claim', 'policy', 'quote'],
    '/app': ['app', 'quote', 'home', 'revocation'],
    '/revocation': ['revocation'],
    '/auth/error': ['auth/error'],
    '/404': ['404'],
    '/500': ['500'],
    '/profile': [
      'profile/index',
      'profile/contact',
      'profile/consent',
      'profile/about-you',
      'profile/notifications',
      'profile/webauth',
    ],
    '/file-a-claim': ['file-a-claim'],
    '/basket/checkout': ['basket/checkout/index'],
    '/basket/checkout/success': ['basket/checkout/success'],
    '/basket/checkout/manual-process': [
      'basket/checkout/manual-process',
      'basket/index',
    ],
    '/insurances': ['insurances', 'policy', 'revocation'],
    '/insurances/[policyNo]': ['insurances', 'policy', 'basket/offer-details'],
    '/contact': ['contact'],
    '/claims': ['claims/index', 'claim'],
    '/claims/[claimNo]': ['claims/details'],
    '/file-claim/success/[claimNo]': ['file-claim/success'],
    '/file-claim': ['file-claim/index', 'claims/details'],
    '/faq': ['faq'],
    '/inbox': ['inbox/documents'],
    '/buy-insurances': [
      'buy-insurances/index',
      'policy',
      'bundle-discount',
      'buy-insurances/index-DFHF',
    ],
    '/buy-insurances/wizard': ['buy-insurances/wizard'],
    '/basket': [
      'basket/index',
      'basket/offer-details',
      'bundle-discount',
      'quote',
      'policy',
    ],
    '/auth/onboarding': ['onboarding'],
    '/login/agent': ['agent/login'],
    '/login/agent-ext': ['agent/login'],
    '/agent/search-party': ['agent/search-party'],
    '/agent/add-party': ['agent/add-party'],
  },
  interpolation: {
    prefix: '${',
    suffix: '}',
  },
};
